export default __webpack_public_path__ + "static/media/banner-english.2bb48c19.jpeg";